<template>
  <div class="overflow-x-auto scrollbar-hidden">
    <!-- <div class="grid sm:flex gap-3 mt-2 sm:flex-wrap">
      <div class="mt-2 report-box-2" :class="data.icon != 'sensitive' ? 'flex-1' : 'flex-1-5'" v-for="(data, key) in countCard" :key="key">
        <div class="box bg-white h-full">
          <div class="px-4 py-4 flex flex-col justify-center flex-1">
            <div class="flex items-center justify-between">
              <h3 class="font-bold text-primary-1 text-base">{{data.text}}</h3>

              <span
                class="
                  w-8
                  h-8
                  px-2
                  py-2
                  flex
                  items-center
                  justify-center
                  rounded-full
                  border-1
                  text-theme-17
                  ml-2
                  box-shadow
                "
              >
                <HomeIcon
                  class="block mx-auto !stroke-2 stroke-[#214181]"
                  v-if="data.icon == 'house'"
                />
                <UsersIcon
                  class="block mx-auto !stroke-2 stroke-[#214181]"
                  v-if="data.icon == 'family'"
                />
                <UserIcon
                  class="block mx-auto !stroke-2 stroke-[#214181]"
                  v-if="data.icon == 'member'"
                />
                <FrownIcon
                  class="block mx-auto !stroke-2 stroke-[#214181]"
                  v-if="data.icon == 'sensitive'"
                />
              </span>
            </div>

            <div class="relative text-5xl font-medium ml-0.5 mt-2 flex text-primary-1" v-if="data.icon != 'sensitive'">
              <div class="left text-sm flex-1 text-center border-r-1 border-theme-44">
                <div class="text-gray-700 p-1.5 border-b-1 border-theme-44">บันทึก</div>
                <div class="text-primary-1 font-bold text-xl p-1.5">{{data.approve_count}}</div>
              </div>
              <div class="left text-sm flex-1 text-center">
                <div class="text-gray-700 p-1.5 border-b-1 border-theme-44">อนุมัติ</div>
                <div class="text-primary-1 font-bold text-xl p-1.5">{{data.reject_count}}</div>
              </div>
            </div>
            <div class="relative text-5xl font-medium ml-0.5 mt-2 flex text-primary-1" v-else>
              <div class="left text-sm flex-1 text-center border-r-1 border-theme-44">
                <div class="text-gray-700 p-1.5 border-b-1 border-theme-44">0</div>
                <div class="text-primary-1 font-bold text-xl p-1.5">{{data.level_0}}</div>
              </div>
              <div class="left text-sm flex-1 text-center border-r-1 border-theme-44">
                <div class="text-gray-700 p-1.5 border-b-1 border-theme-44">1</div>
                <div class="text-primary-1 font-bold text-xl p-1.5">{{data.level_1}}</div>
              </div>
              <div class="left text-sm flex-1 text-center border-r-1 border-theme-44">
                <div class="text-gray-700 p-1.5 border-b-1 border-theme-44">2</div>
                <div class="text-primary-1 font-bold text-xl p-1.5">{{data.level_2}}</div>
              </div>
              <div class="left text-sm flex-1 text-center">
                <div class="text-gray-700 p-1.5 border-b-1 border-theme-44">3</div>
                <div class="text-primary-1 font-bold text-xl p-1.5">{{data.level_3}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <h2 class="text-lg mb-2 mt-5">รายงานเพื่อติดตามการดำเนินการแก้ไขปัญหาครัวเรือน/บุคคลที่เป็นกลุ่มเป้าหมาย</h2>
    <DataTreeTable :data-array="dataReport" :data-array-table="dataArrayTable" :table-name="'report'" />
  </div>
</template>

<script>
import { defineComponent, ref, reactive, onMounted } from 'vue'
import DataTreeTable from "@/components/datatable/dataTreeTable.vue"
import dataReport from "../../example-data/json/report-5.json"

export default defineComponent({
  components:{
    DataTreeTable
  },
  setup() {
    var customNameMutator = (value, data, type, params, component) => {
      return `${data.hh_head?.title ? data.hh_head?.title : ""}${data.hh_head?.name ? data.hh_head?.name: ""} ${data.hh_head?.surname ? data.hh_head?.surname : ""}`
    }
    var customFamNameMemberMutator = (value, data, type, params, component) => {
      return `${data.family_head?.title ? data.family_head?.title : ""}${data.family_head?.name ? data.family_head?.name: ""} ${data.family_head?.surname ? data.family_head?.surname : ""}`
    }
    var customNameMemberMutator = (value, data, type, params, component) => {
      return `${data.memberinfo?.title ? data.memberinfo?.title : ""}${data.memberinfo?.name ? data.memberinfo?.name: ""} ${data.memberinfo?.surname ? data.memberinfo?.surname : ""}`
    }
    var customCMMutator = (value, data, type, params, component) => {
      return `${data.case_manager?.title ? data.case_manager?.title : ""}${data.case_manager?.name ? data.case_manager?.name: ""} ${data.case_manager?.surname ? data.case_manager?.surname : ""}`
    }
    var customPlanDurationMutator = (value, data, type, params, component) => {
      if(data.plan_duration){
        if(data.plan_duration == "critical"){
          return "แผนระยะวิกฤต"
        }
        else if(data.plan_duration == "short"){
          return "แผนระยะสั้น"
        }else{
          return "แผนระยะต่อเนื่อง"
        }
      }
      else{
        return ""
      }
    }
    var customAddressMutator = (value, data, type, params, component) => {
      return `${data.hnum ? data.hnum:""} ${data.moo?'หมู่ '+data.moo:""} ${data.village_name?data.village_name: ""} ${data.soi?'ซอย '+data.soi: ""} ${data.road?'ถนน '+data.road: ""}`
    }
    /* var customHeadMobileNum = (value, data, type, params, component) => {
      return data.hh_head.mobile_num
    }
    var customFamMobileNum = (value, data, type, params, component) => {
      return data.family_head.mobile_num
    }
    var customMemberMobileNum = (value, data, type, params, component) => {
      return data.memberinfo.mobile_num
    } */
    /*var customProblemMutator = (value, data, type, params, component) => {
      if(data.memberinfo ? data.memberinfo.member_stats : false){
        return {"housing": data.memberinfo.member_stats.prob_housing, "health": data.memberinfo.member_stats.prob_health, "occupation": data.memberinfo.member_stats.prob_occupation, "education": data.memberinfo.member_stats.prob_education, "accessibility": data.memberinfo.member_stats.prob_accessibility}
      }else{
        return {"housing": 0, "health": 0, "occupation": 0, "education": 0, "accessibility": 0}
      }
    } */
    const dataArrayTable = reactive([
      {title:"จังหวัด", field:"province_name", minWidth: 150, width: 150,resizable:true},
      {title:"อำเภอ", field:"amphur_name", minWidth: 120, width: 120, resizable:true},
      {title:"ตำบล", field:"tumbol_name", minWidth: 120, width: 120,resizable:true},
      {title:"หมู่บ้าน", field:"village_name", minWidth: 120, width: 120,resizable:true},
      {title:"ประเภทครัวเรือน", field:"hh_type", minWidth: 220, width: 220,resizable:true, formatter:"textarea"},
      {title:"ระดับความเปราะบาง", field:"fragile_level", hozAlign:"center", minWidth: 120, width: 120, resizable:true},
      {title:"เจ้าหน้าที่ที่รับผิดชอบ", field:"case_manager.name", minWidth: 230, width: 230,variableHeight: true, mutator: customCMMutator, hozAlign:"left", formatter:"textarea"},
      {title:"หัวหน้าครัวเรือน", field:"hh_head.name", minWidth: 230, width: 230,variableHeight: true, mutator: customNameMutator, hozAlign:"left", formatter:"textarea"},
      {title:"เบอร์โทรศัพท์หัวหน้าครัวเรือน", field:"hh_head.mobile_num", minWidth: 150, width: 150,resizable:true, formatter:"textarea"},
      {title:"หัวหน้าครอบครัว", field:"family_head.name", minWidth: 230, width: 230,variableHeight: true, mutator: customFamNameMemberMutator, hozAlign:"left", formatter:"textarea"},
      {title:"เบอร์โทรศัพท์หัวหน้าครอบครัว", field:"family_head.mobile_num", minWidth: 150, width: 150,resizable:true,formatter:"textarea"},
      {title:"ชื่อ-สกุล สมาชิก", field:"memberinfo.name", hozAlign:"left", resizable:true, minWidth: 230, width: 230,formatter:"textarea", mutator: customNameMemberMutator,
      },
      {title:"เบอร์โทรศัพท์ผู้ประสบปัญหา", field:"memberinfo.mobile_num", minWidth: 150, width: 150,resizable:true, formatter:"textarea"},
      {title:"จำนวนเด็กเล็กในครัวเรือน", field:"ageclass_infant_cnt", hozAlign:"center", resizable:true, width: 150, minWidth: 150,formatter:"textarea",
      },
      {title:"จำนวนเด็กในครัวเรือน", field:"ageclass_child_cnt", hozAlign:"center", resizable:true, width: 150, minWidth: 150,formatter:"textarea",
      },
      {title:"จำนวนเยาวชนในครัวเรือน", field:"ageclass_teenage_cnt", hozAlign:"center", resizable:true, width: 150, minWidth: 150,formatter:"textarea",
      },
      {title:"จำนวนวัยผู้ใหญ่ในครัวเรือน", field:"ageclass_adult_cnt", hozAlign:"center", resizable:true, width: 150, minWidth: 150,formatter:"textarea",
      },
      {title:"จำนวนผู้สูงอายุในครัวเรือน", field:"ageclass_elderly_cnt", hozAlign:"center", resizable:true, width: 150, minWidth: 150,formatter:"textarea",
      },
      {title:"รายได้ครัวเรือนเฉลี่ย", field:"average_income", hozAlign:"center", resizable:true, width: 150, minWidth: 150,formatter:"textarea",
      },
      {title:"อาชีพหลัก", field:"primary_occup", hozAlign:"left", resizable:true, width: 150, minWidth: 150,formatter:"textarea",
      },
      {title:"อาชีพรอง", field:"secondary_occup", hozAlign:"left", resizable:true, width: 150, minWidth: 150,formatter:"textarea",
      },
      {title:"โรคประจำตัว", field:"chronic_disease", hozAlign:"left", resizable:true, width: 200, minWidth: 200,formatter:"textarea",
      },
      {title:"ความพิการ", field:"disability", hozAlign:"left", resizable:true, width: 200, minWidth: 200,formatter:"textarea",
      },
      {title:"บัตรประจำตัวคนพิการ", field:"have_pwd_card", hozAlign:"left", resizable:true, width: 150, minWidth: 150,formatter: function(cell){
        return cell.getValue() ? 'มี' : 'ไม่มี'
      },
      },
      {title:"สิทธิการรักษาพยาบาล", field:"med_scheme", hozAlign:"left", resizable:true, width: 150, minWidth: 150,formatter:"textarea",
      },
      {title:"สวัสดิการที่เคยได้รับ ด้านเด็กและเยาวชน", field:"welf_children_youth", hozAlign:"left", resizable:true, width: 170, minWidth: 170,formatter:"textarea",
      },
      {title:"สวัสดิการที่เคยได้รับ ด้านคนพิการ", field:"welf_disability", hozAlign:"left", resizable:true, width: 170, minWidth: 170,formatter:"textarea",
      },
      {title:"สวัสดิการที่เคยได้รับ ด้านสตรี", field:"welf_women", hozAlign:"left", resizable:true, width: 170, minWidth: 170,formatter:"textarea",
      },
      {title:"สวัสดิการที่เคยได้รับ ด้านผู้สูงอายุ", field:"welf_eldery", hozAlign:"left", resizable:true, width: 170, minWidth: 170,formatter:"textarea",
      },
      {title:"สวัสดิการที่เคยได้รับ ด้านคนไร้ที่พึ่ง", field:"welf_helpless_persons", hozAlign:"left", resizable:true, width: 170, minWidth: 170,formatter:"textarea",
      },
      {title:"สวัสดิการที่เคยได้รับ ด้านอื่นๆ", field:"welf_others", hozAlign:"left", resizable:true, width: 170, minWidth: 170,formatter:"textarea",
      },
      {title:"สภาพปัญหา", field:"prob_desc", hozAlign:"left", resizable:true, width: 150, minWidth: 150,formatter:"textarea",
      },
      {title:"ระยะเวลาแผนการช่วยเหลือ", field:"plan_duration", hozAlign:"left", resizable:true, width: 150, minWidth: 150, mutator: customPlanDurationMutator,formatter:"textarea",
      },
      {title:"มิติที่ประสบปัญหา", field:"prob_dim", hozAlign:"left", resizable:true, width: 150, minWidth: 150,formatter:"textarea",
      },
      {title:"ประเภทความช่วยเหลือ", field:"sol_type", hozAlign:"left", resizable:true, width: 150, minWidth: 150,formatter:"textarea",
      },
      {title:"แนวทางการให้ความช่วยเหลือ", field:"sol_des", hozAlign:"left", resizable:true, width: 150, minWidth: 150,formatter:"textarea",
      },
    ])
    const countCard = reactive([
      {
        text: "จำนวนครัวเรือน",
        approve_count: 28,
        reject_count: 28,
        icon: "house",
      },
      {
        text: "จำนวนครอบครัว",
        approve_count: 28,
        reject_count: 28,
        icon: "family",
      },
      {
        text: "จำนวนสมาชิก",
        approve_count: 28,
        reject_count: 28,
        icon: "member",
      },
      {
        text: "จำนวนความเปราะบาง",
        level_0: 28,
        level_1: 28,
        level_2: 28,
        level_3: 28,
        icon: "sensitive",
      },
    ]);

    return {
      dataArrayTable,
      dataReport,
      countCard
    }
  }
})
</script>
<style lang="scss">
/*#tree-tabulator.tabulator{
  .tabulator-tree-level-0 [tabulator-field="household_count"],
  .tabulator-tree-level-0 [tabulator-field="family_count"],
  .tabulator-tree-level-0 [tabulator-field="member_count"],
  .tabulator-tree-level-0 [tabulator-field="sensitive_level_count"] {
    text-align: center !important;
    justify-content: center !important;
  }
}*/
.flex-1-5{
  flex: 1.5;
}
</style>

